module.exports = __webpack_public_path__ + "static/media/CallUs.279a4017.svg";